<!-- eslint-disable -->

<template>
	<div> 
		<div class="bg-white rounded-lg px-4">
			<Header :status="status" :dateTime="deadlineDate" v-if="order" @is_expired="cancelRent()" />
			<div class="pt-4"> 
				<div class="text-center">
					<label class="text-gotham" style="font-size: 14px">{{ language == 'en' ? 'Door Number' : 'Nomor Pintu' }} :</label>
					<div class="door-number text-gotham-bold"> {{ doorNumber }}</div>
				</div>
				<div class="py-4" style="justify-content:center;display: flex;margin: auto;" v-if="qrCode">
						<Qrcode :value="qrCode" :isBase64="false"/>
				</div>
			</div>

			<div class="rounded-lg border border-warning px-4 py-2"> 
				<div class="text-center text-gotham-bold pb-2" style="color: #FF434F;font-size: 16px;line-height: 20px;">{{ language == 'en' ? attention.title : attention.title_bahasa }} </div>
				<div class="html-wrapper" style="line-height: 20px;" v-html="language == 'en' ? attention.description : attention.description_bahasa"></div>
			</div>
			<div class="divider my-4"></div>

			<InfoList :title="language == 'en' ? 'Rent Info' : 'Info Sewa'" :data="rentInfo" cta="orderstatus_tostore_rentinfo_copy_order_number" />
			<div class="divider my-4"></div>

			<Collapsible
				id="howto"
				cta="orderstatus_tostore_howto_toggle"
				:title="
					language == 'en' ? howToStep.title : howToStep.title_bahasa
				"
				:open="toogleHowto"
				@onClick="toogleHowto = !toogleHowto"
			>
				<HowTo :content="instruction" />
			</Collapsible>

			<div class="divider my-4"></div>
			<Collapsible
				id="history"
				cta="orderstatus_tostore_history_toggle"
				:title="language == 'en' ? 'Status History' : 'Riwayat Status'"
				:open="toogleHistory"
				@onClick="toogleHistory = !toogleHistory"
			>
				<History :data="logs" v-if="logs" />
			</Collapsible>

			<div class="divider my-4"></div>
			<Collapsible
				id="info"
				cta="orderstatus_tostore_lokasi_toggle"
				:title="language == 'en' ? 'PaxelBox Location Info' : 'Info Lokasi PaxelBox'"
				:open="toogleInfo"
				@onClick="toogleInfo = !toogleInfo"
			>
				<div>
					<div class="py-2 text-gotham-bold" style="font-size: 16px;">
						{{ addressMain || "-" }}
					</div>
					<div class="text-gotham text-left" style="font-size: 12px;line-height: 16px;">
						{{ addressDetail || "-" }}
					</div>
					<div class="py-2 " v-if="lat && long">
						<span
							data-cta="orderstatus_tostore_lokasi_lihat_peta"
							@click="openMapLink"
							class="text-purple text-gotham-bold text-left"
							style="font-size: 12px;line-height: 16px;color: #5e51a1;"
							>{{ language == "en" ? "See map" : "Lihat peta" }} >
						</span>
					</div>
					<div class="py-2 text-gotham text-left" style="font-size: 12px;line-height: 16px;">
						{{ addressAdditionalDetail || "-" }}
					</div>
					<div
						class="py-2 text-gotham text-left"
						style="font-size: 12px;line-height: 16px;white-space:pre-wrap"
					>
						<div>{{ language == "en" ? "Operational Hours" : "Jam Operasional" }} :</div>
						<div class="mt-2">{{ operationalHour || "-" }}</div>
					</div>
					<div class="row px-3">
						<div class="" style="height: 160px;width: 50%;">
							<img
								v-if="locker_photo"
								:src="locker_photo"
								class="image-fit"
								data-cta="orderstatus_tostore_lokasi_foto_locker"
								@click="showPhoto(locker_photo)"
								@error="imageUrlNoContent"
								alt="Locker"
							/>
						</div>
					</div>
				</div>
			</Collapsible>

			<div class="divider my-4"></div>
			<Collapsible
				id="payment"
				cta="orderstatus_tostore_payment_toggle"
				:title="language == 'en' ? 'Payment Details' : 'Rincian Pembayaran'"
				:open="tooglePaymentDetail"
				@onClick="tooglePaymentDetail = !tooglePaymentDetail"
			>
				<InfoList :data="paymentInfo" cta="orderstatus_tostore_payment_copy_order_number" />
			</Collapsible>
			<div class="divider my-4"></div>
			<div class="text-center px-6">
				<button
					class="button rounded-lg py-3 text-gotham-bold"
					style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
					data-cta="orderstatus_tostore_hera"
					@click="buttonContactSupport()"
				>
					{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
					<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
				</button>
			</div>
			<div class="divider my-4"></div>
			<div class="text-center pb-4 btn-action-bottom">
				<button class="button rounded-lg py-3 px-6  text-gotham-bold " data-cta="orderstatus_tostore_batal_sewa" @click="showModal = true" style="width: 90%;background-color: #FF434F;color:white;border: 1px solid #FF434F;">
					<span class="text-gotham-bold text-white text-16" style="cursor: pointer" >{{ language == "en" ? "Cancel Rent" : "Batal Sewa" }}</span>
				</button>
			</div>
		</div>
		<div>
			<b-modal v-model="showModal" title="Pickup" id="modal-center" centered hide-header hide-footer>
				<div class="text-gotham" style="gap:12px;">
					<div class="text-gotham-bold text-18"> {{language == 'en'?'Cancel Rent?':'Batalkan Sewa?'}} </div>
					<div class="text-14" style="color:#929293"> {{language == 'en'?'Are you sure you want to cancel your PaxelBox rent?':'Kamu yakin mau membatalkan sewa PaxelBox?'}} </div>
					<div class="pt-4 pb-2 text-center text-purple" v-if="loadingCancel">
						<loadingCircle  style="height: 20px;width: 20px;"/>
					</div>
					<div class="d-flex justify-content-between pt-4" v-else>
						<div data-cta="orderstatus_tostore_cancel_tidak_sekarang" @click="showModal = false" style="color:#CCCCCD" class="button p-2 text-gotham-bold text-14 bg-red">{{language=='en'?'NOT NOW':'TIDAK SEKARANG'}}</div>
						<div data-cta="orderstatus_tostore_cancel_ya_batalkan" @click="cancelRent()" class="button p-2 text-gotham-bold text-14 bg-white text-purple" >{{language=='en'?'YES, CANCEL':'YA, BATALKAN'}}</div>
					</div>
				</div>
			</b-modal>

			<b-modal v-model="showModalError" title="Pickup" id="modal-center" centered hide-header hide-footer>
				<div class="text-gotham" style="gap:12px;">
					<div class="text-gotham-bold text-18"> {{language == 'en'?'Denied?':'Ditolak?'}} </div>
					<div class="text-14" style="color:#929293"> {{errorMessage}} </div>
					<div class="d-flex pt-4" style="float:right">
						<div data-cta="orderstatus_tostore_error_ok" @click="showModalError = false" class="button p-2 text-gotham-bold text-14 bg-white text-purple" >OK</div>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import Qrcode from "./components/Qrcode.vue";
import Header from "./components/Header.vue";
import InfoList from "./components/InfoList.vue";
import Collapsible from "./components/Collapsible.vue";
import History from "./components/History.vue";
import HowTo from "./components/HowTo.vue";
import loadingCircle from "@/views/reuse/loadingCircle.vue";
import i18n from '@/plugins/i18n';

export default {
	components : {Qrcode,Header,InfoList,Collapsible,History,HowTo,loadingCircle},
	props: {
		status: {
			type: String,
			default: "to-store"
		},
		order: {
			type: Object,
			default() {
				return {};
			}
		},
		boxLocationDetail: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
    return {
			loadingIcon: true,
      pakpoboxAPIUrl: process.env.VUE_APP_PAKPOBOX_API,
      heraUrl: process.env.VUE_APP_HERA_LINK,
			addressMain: '',
      addressDetail: '',
      addressAdditionalDetail: '',
      mapUrl: '',
      operationalHour: '',
      lat: "",
			long: "",
			locker_photo: "",
			qrCode: '',
			doorNumber: '-',
			rentDate: '',
			deadlineDate: '',
			orderNumber: '',
			size: '',
			toogleHowto: true,
			toogleHistory: true,
			toogleInfo: true,
			tooglePaymentDetail: true,
			showModal: false,
			paymentMethod: "",
			payOfAmount: "",
			paymentDetail: {},
			adminFee: {},
			donation: [],
			logs: [],
			timer: 0,
			totalDonation: 0,
			stringCountDown: "",
			showModalError : false,
			errorMessage : false,
			howToStep : {
				description:"",
				description_bahasa:"",
				title:"",
				title_bahasa:"",
				value:"",
			},
			instruction:"",
			attention:"",
			loadingCancel : false,
    };
  },
	computed: {
		rentInfo() {
			return [
				{
					label: this.language == "en" ? "Rent Start" : "Sewa Dimulai",
					key:"title",
					value: this.rentDate,
					isDate: true
				},
				{
					label: this.language == "en" ? "Rent Ends" : "Batas Akhir Sewa",
					key:"deadlineDate",
					value: this.deadlineDate,
					isDate: true,
					addBreak: true,
				},
				{
					label: this.language == "en" ? "Order Number" : "Nomor Order",
					key:"orderNumber",
					value: this.orderNumber
				},
				{
					label: this.language == "en" ? "PaxelBox Size" : "Ukuran PaxelBox",
					key:"boxSize",
					value: this.size
				}
			];
		},
		paymentInfo() {
			const arr = [
				{
					label: this.language == "en" ? "Rent Fee" : "Biaya Sewa",
					value: this.formatRupiah(this.payOfAmount),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Admin Fee" : "Biaya Admin",
					value: this.formatRupiah(this.adminFee?.total_amount ?? 0 ),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Total Payment" : "Total Pembayaran",
					value: this.formatRupiah(
						(this.payOfAmount ?? 0) + (this.adminFee?.total_amount ?? 0) + (this.totalDonation ?? 0)
					),
					labelStyle: "font-weight:bold;font-size:14px",
					valueStyle: "font-weight:bold;font-size:16px",
					addBreak: true
				},
				{
					label: this.language == "en" ? "Payment Method" : "Metode Pembayaran",
					value: this.paymentMethod,
					addBreak: true
				}
			];
			
			if(this.donation){
				const donations = this.donation.map(donate => {
					return {
						label: `${donate.qty} item | ${this.language == "en" ? donate.name.en : donate.name.id}`,
						value: this.formatRupiah(donate.sub_total),
						addBreak: true
					};
				});
	
				arr.splice(1, 0, ...donations);
				return arr;
			}else{
				return arr;
			}

		},
	},
	mounted (){
		this.qrCode = this.order?.barcode?.qrcodeCustomerStore;
		this.doorNumber = this.order?.mouth.number
		this.rentDate = this.order?.createTime
		var date = new Date(this.order?.overdueDatetime);
		var unixTimeStamp = Math.floor(date.getTime());
		// this.deadlineDate = this.order?.overdueTime;
		this.deadlineDate = unixTimeStamp;
		this.orderNumber = this.order?.expressNumber;
		this.addressMain = this.boxLocationDetail?.locker_location || "-";
		this.addressDetail = this.boxLocationDetail?.location_address || "-";
		this.lat = this.boxLocationDetail?.latitude
		this.long = this.boxLocationDetail?.longitude
		this.mapUrl = this.boxLocationDetail?.maps_link
		this.locker_photo = this.boxLocationDetail?.locker_photo
		this.addressAdditionalDetail = this.boxLocationDetail?.location_description_bahasa || "-";
		this.operationalHour = this?.boxLocationDetail?.operational_hour_bahasa;
		if(this.language == 'en'){
			this.addressAdditionalDetail = this.boxLocationDetail?.location_description || "-";
			this.operationalHour = this?.boxLocationDetail.operational_hour;
		}
		this.size = this.sizeDoorLabel(this.order?.mouth?.mouthType?.name)
		this.paymentMethod = this.order.paymentMethod
		this.payOfAmount = this.order.payOfAmount
		this.paymentDetail = this.order.payment_detail
		this.donation = this.order.donation
		this.totalDonation = this.order.total_donation
		this.adminFee = this.order.admin_fee
		this.logs = this.order.logs;
		this.howToStep = this.getPaxelBoxContentSetting("how_to_put_items")
		this.instruction = this.howToStep.description_bahasa?.replaceAll("{{door_number}}", this.doorNumber);
		if(this.language == 'en'){
			this.instruction = this.howToStep.description?.replaceAll("{{door_number}}", this.doorNumber);
		}
		this.attention = this.getPaxelBoxContentSetting("attention_pick_up_items")

	},
	methods : {
		openMapLink() {
			this.buttonSyncOpenGmapLocation(this.lat, this.long, this.mapUrl)
		},
		contactHera(url) {
      window.location.href = url;
    },
		cancelRent(){
			this.errorMessage = "";
			this.loadingCancel = true;
			this.$store.dispatch('cancelRent', {id:this.$route.query.orderid})
			.then((res) => {
				if(this.$store.getters.getOrderDetail){
					let rentalDetail = this.$store.getters.getOrderDetail
					let netcorePayload = this.generalEventPayloadData(true);
					netcorePayload.Payment_Method = rentalDetail.paymentMethod   
					this.recordEvent('cancelled_paxelbox', netcorePayload) 
				}
				this.$router.push('order-status/action?act=cancel_success');
				this.loadingCancel = false;
			})
			.catch((error) => {
				this.loadingCancel = false;
				this.showModal = false;
				const message = error.response.data.message || i18n.t('something_wrong');
					this.$swal({
						icon: 'error',
						title: 'Oops...',
						text: message,
					});

			});
		}
	}
}
</script>
<style>
	.status-to-store{
		font-size: 14px;
		color: #56C378;
	}
	.timeleft {
		font-size: 24px;
		color: #5F51A1;
	}
	.door-number {
		font-size: 48px;
		color: #FF434F;
	}
	.box-info {
		opacity: 1;
		color: rgba(255, 67, 79, 1);
		font-family: "GothamBold-Regular";
		font-size: 12px;
		font-weight: 700;
		font-style: Regular;
		letter-spacing: 0px;
		text-align: center;
		line-height: 18px;
	}
	.divider {
		height: 1rem;
		background-color: #F9F9FB;
		margin-right: -1.5rem;
		margin-left: -1.5rem;
	}
	.text-16{
		font-size: 16px;
	}
	.btn-action-bottom{
		margin-right: -1.5rem;
		margin-left: -1.5rem;
	}
</style>